import { OrderForm } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const updateForm = createAction(
  '[Complete Order] Update Form',
  props<{ payload?: OrderForm }>()
);

export type OrderFormActions = typeof updateForm;
